import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const LandingView     = () => import('@/views/LandingView.vue')
const AboutView       = () => import('@/views/AboutView.vue')
const LoginView       = () => import('@/views/LoginView.vue')
const RegisterView    = () => import('@/views/RegisterView.vue')
const ChatView        = () => import('@/views/ChatView.vue')
const ProjectsView    = () => import('@/views/ProjectsView.vue')
const GitHubCallback  = () => import('@/views/GitHubCallback.vue')
const DeploymentsView = () => import('@/views/DeploymentsView.vue')
const SettingsView    = () => import('@/views/SettingsView.vue')
const BillingView     = () => import('@/views/BillingView.vue')
const BillingSuccess  = () => import('@/views/BillingSuccess.vue')
const BillingCancel   = () => import('@/views/BillingCancel.vue')
const AuthCallback    = () => import('@/views/AuthCallback.vue')
const DashboardView   = () => import('@/views/DashboardView.vue')
const ShareView       = () => import('@/views/ShareView.vue')
const GuideView       = () => import('@/views/GuideView.vue')
const CodeEditorView  = () => import('@/views/CodeEditorView.vue')
const TemplatesView   = () => import('@/views/TemplatesView.vue')
const McpView              = () => import('@/views/McpView.vue')
const IntegrationsView     = () => import('@/views/IntegrationsView.vue')

const routes = [
  // ── Public ────────────────────────────────────────────────────────────────────
  { path: '/',                component: LandingView,   name: 'landing'          },
  { path: '/about',           component: AboutView,     name: 'about'            },
  { path: '/login',           component: LoginView,     name: 'login'            },
  { path: '/register',        component: RegisterView,  name: 'register'         },
  { path: '/auth/callback',   component: AuthCallback,  name: 'auth-callback'    },
  { path: '/github-callback', component: GitHubCallback,name: 'github-callback'  },
  { path: '/share/:token',    component: ShareView,      name: 'share'           },
  { path: '/guide',           component: GuideView,      name: 'guide'           },

  // ── Protected ─────────────────────────────────────────────────────────────────
  { path: '/dashboard',       component: DashboardView,  meta: { requiresAuth: true } },
  { path: '/chat',            component: ChatView,       meta: { requiresAuth: true } },
  { path: '/projects',        component: ProjectsView,   meta: { requiresAuth: true } },
  { path: '/deployments',     component: DeploymentsView,meta: { requiresAuth: true } },
  { path: '/settings',        component: SettingsView,   meta: { requiresAuth: true } },
  { path: '/billing',         component: BillingView,    meta: { requiresAuth: true } },
  { path: '/billing/success', component: BillingSuccess, meta: { requiresAuth: true } },
  { path: '/billing/cancel',  component: BillingCancel,  meta: { requiresAuth: true } },
  { path: '/editor/:artifactId', component: CodeEditorView, meta: { requiresAuth: true }, name: 'code-editor' },
  { path: '/templates',      component: TemplatesView,   meta: { requiresAuth: true }, name: 'templates' },
  { path: '/mcp',            component: McpView,           meta: { requiresAuth: true }, name: 'mcp' },
  { path: '/integrations',   component: IntegrationsView,  meta: { requiresAuth: true }, name: 'integrations' },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  // Always await — fetchMe() returns a singleton promise so concurrent guards
  // share one in-flight request instead of racing past a loading=true check.
  if (!auth.user) await auth.fetchMe()

  // Already logged in → skip login/register (honour redirect param if present)
  if (['login', 'register'].includes(to.name) && auth.isLoggedIn) {
    const pending = sessionStorage.getItem('tc_redirect')
    if (pending) { sessionStorage.removeItem('tc_redirect'); return pending }
    return to.query.redirect || '/dashboard'
  }

  // Protected route without auth
  if (to.meta.requiresAuth && !auth.isLoggedIn) {
    return { path: '/login', query: { redirect: to.fullPath } }
  }
})

export default router